export const SET_DEFAULT_ESTIMATE_METRIC = 'SET_DEFAULT_ESTIMATE_METRIC'
export const SET_DEFAULT_ESTIMATE_TAB = 'SET_DEFAULT_ESTIMATE_TAB'

export const setDefaultTab = (defaultTab) => (dispatch) => {
  return dispatch({ type: SET_DEFAULT_ESTIMATE_TAB, defaultTab })
}
